import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { CustomerTableFilterSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/customer/_list/')({
  validateSearch: zodValidator(CustomerTableFilterSchema)
});